import React, {Fragment, useEffect, useState} from "react"
import { Div, Text, Container, Col, Row } from "atomize";
import styled from "styled-components";
import Header from "../Components/Molecules/Header";
import Routes from "../Routes";
import {apiGet} from "../Api";
import Heading from "../Components/Atoms/Heading";
import VideoCard from "./../Components/Molecules/VideoCard";
import SEO from "../Components/Atoms/SEO";
import ReactGA from "react-ga";

const VideoCardWrapper = styled(Col)`
    // margin: 1rem;
    margin-bottom: 1rem;
`;

const Wrapper = styled(Container)`
  margin-top: -5.6rem;
`

const Arr = [1,2,3];

function Videos(props) {
  ReactGA.pageview(window.location.pathname + window.location.search);

  const [data, setData] = useState(null);
  const [media, setMedia] = useState(null);
  const [taxonomy, setTaxonomy] = useState(null);
  const [heroImgUrl, setHeroImgUrl] = useState(null);
  const [loadVideo, setLoadVideo] = useState(null);

  const page = Routes.filter( route => {
    return route.path === props.location.pathname
  });

  let pageTitle = '';

  if (page.length > 0) {
    pageTitle = page[0].name;
  }

  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`/node/page?filter[title]=${pageTitle}&include=field_banner_image`);
      setHeroImgUrl(result.data.included[0].attributes.uri.url);
      const videoTaxonomyResult = await apiGet(`/taxonomy_term/video_types`);
      setTaxonomy(videoTaxonomyResult.data.data);
      const videosResult = await apiGet(`node/video?include=field_video_source&field_media_oembed_video&jsonapi_include=1`);
      let taxVideos = [];
      videoTaxonomyResult.data.data.forEach( tax => {
        let taxVideo = {};
        taxVideo.name = tax.attributes.name;
        taxVideo.id = tax.id;
        let videos = [];
        videosResult.data.data.forEach( video => {
          if (video.field_video_type.id === taxVideo.id) {
            videos.push(video)
          }
        });
        if (videos[0] && videos[0].title.match(/^\d+/)) {
          videos = videos.sort((a, b) => a.title.match(/([^.]+)/)[0] - b.title.match(/([^.]+)/)[0])
        } else {
          videos = videos.sort((a, b) => new Date(b.changed) - new Date(a.changed));
        }
        taxVideo.videos = videos;
        taxVideos.push(taxVideo)
      });
      setData(taxVideos);
      const videoMedia = await apiGet(`/media/remote_video?include=thumbnail&jsonapi_include=1`);
      setMedia(videoMedia.data.data);
    }
    fetchData();


    const loadFromPath = () => {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("video")) {
        let loadVideo = urlParams.get("video");
        setLoadVideo(loadVideo)
      }
    };
    loadFromPath();
  }, []);


  return (
    <Div>
      <SEO
        title={"Videos | Engineering for Humanity | Olin College of Engineering"}
        description={data && data.field_description ? data.field_description : null}
      />
      <Header
        pageTitle={pageTitle}
        heroImgUrl={heroImgUrl}
      />
      <Wrapper>
        {
          data &&
            data.map( (item, i) => {
              return (
                <Fragment
                  key={item.name + i}
                >
                  <Heading
                    title={item.name}
                    hideline={i === 0}
                  />
                  <Row>
                    {
                      media ?
                      item.videos.map( (video,i) => {
                        const mediaObj = media.find(element => element.id === video.field_video_source.id);
                        return (
                          <VideoCardWrapper
                            key={video.title + i}
                            size={{ xs: '12', sm: '6', md: '4', lg: '4' }}
                          >
                            <VideoCard
                              mediaObj={mediaObj}
                              video={video}
                              showTitle={true}
                              urlParams={true}
                              history={props.history}
                              loadVideo={loadVideo === video.title}
                            />
                          </VideoCardWrapper>
                        )
                      })
                      :
                      Arr.map( i => {
                        return (
                          <VideoCardWrapper
                            key={i}
                            size={{xs: '12', sm: '6', md: '4', lg: '4'}}
                          >
                            <VideoCard/>
                          </VideoCardWrapper>
                        )
                      })
                    }
                  </Row>
                </Fragment>
              )
            })
        }
        {
          !taxonomy &&
            <>
              <Heading
                loading={true}
              />
              <Row>
                {
                  Arr.map( i => {
                    return (
                      <VideoCardWrapper
                        key={i}
                        size={{ xs: '12', sm: '6', md: '4', lg: '4' }}
                      >
                        <VideoCard/>
                      </VideoCardWrapper>
                    )
                  })
                }
              </Row>
            </>
        }
      </Wrapper>
    </Div>
  )
}

export default Videos
